import {Component, OnDestroy, OnInit} from '@angular/core';
import {RateTypesSroService} from '../../services/rate-types-sro/rate-types-sro.service';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {CarrierService} from '../../services/carrier/carrier.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../services/user/user.service';
import {ControlType} from '../hhg-rate-duns/control-type';
import {BehaviorSubject} from 'rxjs';
import {takeWhile} from 'rxjs';
import {Carrier} from '../../shared/common-components/common-structure';
import {FrtRateFilingService} from './frt-rate-filing.service';
import {GridApi, GridOptions} from 'ag-grid-community';
import {TextRendererComponent} from '../../shared/common-components/shipment/text-renderer/text-renderer.component';
import AppConstants, {FrtRqdDocsForRateFiling} from '../../shared/common-components/AppConstants';

@Component({
    selector: 'app-frt-rate-filing-initial',
    templateUrl: './frt-rate-filing-initial.component.html',
    styleUrls: ['./frt-rate-filing-initial.component.css'],
    standalone: false
})
export class FrtRateFilingInitialComponent implements OnInit, OnDestroy {
  additionalInformation;
  private gridApi!: GridApi<any>;
  public columnDefs;
  public rowData;
  documentManagementList: any = [{}];
  filterdDocsList : any = [{}];
  public defaultColDef;
  frtInitialGridOptions: GridOptions;
  public overlayNoRowsTemplate;
  observer$ = new BehaviorSubject(true);
  carrier: Carrier;
  disableAccept = true;
  disableButtons = false;
  enableContinue;
  errorMessage: string;
  beginMessage: string;
  endMessage: string;
  redirectUrl: string;

  constructor(private userService: UserService, private hhgrateService: HhgCarrierRateFilingService, private alertService: AlertService, private formBuilder: UntypedFormBuilder,
              private loader: LoadingService, private router: Router, private carrierService: CarrierService, private frtInitialService: FrtRateFilingService
              ) {
    this.overlayNoRowsTemplate = '<span>No BidCycles. Please adjust your query options.</span>';
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 90,
      pagination: true,
      paginationPageSize: 30,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      rowData: this.rowData,
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      isRowSelectable: function(rowNode) {
      return rowNode.data.acceptance === null ? true : false;
    },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  /**
   * @description gets the control key and TSP id
   */
  ngOnInit() {
    this.columnDefs = [
      {
        headerName: 'Select',
        headerCheckboxSelection: true,
        /*cellRenderer: params => {
          return `<input type='checkbox' ${params.acceptance === null ? 'disabled' : ''} />`;
        },*/
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true
      },
      {
        headerName: 'Bid Cycle',
        field: 'bidcycleName',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'SRO ID',
        field: 'sroId',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Open Date',
        field: 'openDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Close Date',
        field: 'closeDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Tsp Participation Open Date',
        field: 'tspParticipationOpenDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Tsp Participation Close Date',
        field: 'tspParticipationCloseDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Rate Effective Date',
        field: 'rateEffectiveDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Rate Expiry Date',
        field: 'rateExpiryDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'PC Miler Version',
        field: 'pcmiller',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Fuel Surcharge Version',
        field: 'fuelSurchargeVersion',
        filter: 'agTextColumnFilter',
        tooltipField: 'fuelSurchargeVersion',
      },
      {
        headerName: 'LTL Version',
        field: 'ltlVersion',
        filter: 'agTextColumnFilter',
        tooltipField: 'fuelSurchargeVersion',
      },
      {
        headerName: 'Acceptance',
        cellRenderer: params => {
          return params.data.acceptance === true ? 'Accepted' : params.data.acceptance === false ? 'Rejected' : '';
        },
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Accepted By',
        field: 'email',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Acceptance Date',
        field: 'updateDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Additional Info',
        field: 'additionalInfo',
        filter: 'agTextColumnFilter'
      }
    ];
    this.frtInitialGridOptions = this.initializeGridOptions();
    this.carrierService.getCarrierObservable().pipe(takeWhile(() => this.observer$.value)).subscribe((carrier: any) => {
      this.carrier = carrier;
     // this.getDocInfoForTsP(this.carrier.carrierId);
      this.getCurrentBidCycles(this.carrier.carrierId);
    });
  }

  /**
   * @description fetches all the bidcycles that are currently open and in which user haven't already participated.
   * @param carrierId: current id of the TSP.
   */
  getCurrentBidCycles(carrierId) {
    this.frtInitialService.getTspParticipationSro(carrierId).pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
      this.rowData = res;
      this.enableContinue = this.rowData.some(function (item) {
        return item.acceptance === 1;
      });
      this.additionalInformation = '';
    }, error => {
      this.alertService.error('Error while getting current bid cycle details. Please contact system administrator.');
    });
  }

  getDocInfoForTsP(carrierId) {
    this.frtInitialService.getDocInfoForTsP(carrierId).pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
      this.documentManagementList = res;
      this.errorMessage = '';
      this.beginMessage = 'The following documents(s) is/are either expired or missing in TMSS 2.0.  <br><br> '
      this.endMessage = 'Please upload the missing/expired document(s) so that you can participate in the current rate filing window.<br>'
      this.filterdDocsList = this.documentManagementList.filter(d=>d.documentType === FrtRqdDocsForRateFiling.SCACCERT && d.documentStatus === 'Finalized' && d.expiryDate > new Date().toISOString());
      if (this.filterdDocsList.length === 0) {
        this.errorMessage = (` - Certificate of SCAC <br>`);
      }
   
      this.filterdDocsList = this.documentManagementList.filter(d=>d.documentType === FrtRqdDocsForRateFiling.LIABINSUR && d.documentStatus === 'Finalized' && d.expiryDate > new Date().toISOString());
      if (this.filterdDocsList.length === 0) {
        this.errorMessage = ( ' \n ' + this.errorMessage + ` - Certificate of Liability Insurance <br>`);
      }

      this.filterdDocsList = this.documentManagementList.filter(d=>d.documentType === FrtRqdDocsForRateFiling.TSPAGREEMENT && 
                                d.documentStatus === 'Finalized' && 
                                (d.expiryDate === null || d.expiryDate > new Date().toISOString()));
      if (this.filterdDocsList.length === 0) {
        this.errorMessage = ( ' \n '+  this.errorMessage + ` - TSP Agreement <br>`);
      }
      if (this.errorMessage !== null && this.errorMessage !== '' ) {
        this.alertService.error(this.beginMessage + this.errorMessage + '<br><br>' + this.endMessage);
        this.errorMessage = "One or more of the required TSP documents are either expired or missing. Please upload the missing/expired documents so that you can participate in the current rate filing window. If you have any questions or need assistance please contact transportation.programs@gsa.gov. "
        this.disableButtons = true;
       // this.redirectUrl = '/landing';
       // this.router.navigate([this.redirectUrl]);
      } else {
        this.disableButtons = false;
      }
      

    }, error => {
      this.alertService.error('Error while getting current bid cycle details. Please contact system administrator.');
    });
  }
  /**
   * @description accepts/rejects tsp rate participation for frt
   */
  acceptRejectTspParticipation(acceptance) {
    const payload = this.gridApi.getSelectedRows();
    if (acceptance) {
      payload.forEach(x => {
        delete x.updateDate;
        delete x.sroId;
        delete x.openDate;
        delete x.closeDate;
        delete x.pcmiller;
        delete x.fuelSurchargeVersion;
        delete x.ltlVersion;
        x.carrierId = this.carrier.carrierId;
        x.acceptance = 1;
      });
    } else {
      payload.forEach(x => {
        delete x.updateDate;
        delete x.sroId;
        delete x.openDate;
        delete x.closeDate;
        delete x.pcmiller;
        delete x.fuelSurchargeVersion;
        delete x.ltlVersion;
        x.carrierId = this.carrier.carrierId;
        x.acceptance = 0;
      });
    }
    this.loader.show();
    this.frtInitialService.acceptRejectFrtTsp(payload).pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
      this.loader.hide();
      this.alertService.success('Successfully accepted TSP rate participation');
      this.router.navigate(['/duns'],
        {queryParams: {rateType: 'FRT'}});
    }, error => {
      this.loader.hide();
      this.alertService.error('Error occurred while accepting TSP rate participation. Please contact system administrator');
    });
  }
  goToDuns() {
    this.router.navigate(['/duns'],
      {queryParams: {rateType: 'FRT'}});
  }
  onSelectionChanged(event: any) {
    const selectedRows =  this.gridApi.getSelectedRows();
    this.disableAccept = selectedRows.length === 0;
  }
  /**
   * destroying the subscription by setting false to the subject
   */
  ngOnDestroy() {
    this.observer$.next(false);
  }
}
